'use client';
import { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import Image from 'next/image';
import { PrefetchOnHoverLink } from '@/app/ui/components/prefetchonhoverlink';

type Props = {
  quickLinks:
    | {
        label: string;
        path: string;
        selected?: boolean;
      }[]
    | undefined;
};

const QuickLinks = ({ quickLinks }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [leftBtn, showLeft] = useState(false);
  const [rightBtn, showRight] = useState(false);

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      const overflow = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
      showRight(overflow > 0);
    }
  }, [quickLinks]);

  const handleScroll = (direction: 'L' | 'R') => {
    if (scrollRef && scrollRef.current) {
      const scrollAmount = direction === 'R' ? 250 : -250;
      const endPosition = scrollRef.current.scrollLeft + scrollAmount;
      if (direction === 'R') {
        const tillEnd = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
        showRight(tillEnd > endPosition);
        showLeft(true);
      } else {
        showRight(true);
        showLeft(endPosition > 0);
      }
      scrollRef.current.scrollTo({ left: endPosition, behavior: 'smooth' });
    }
  };

  return (
    <div className={'position-relative'} style={{ marginTop: '1rem' }}>
      <div ref={scrollRef} className={styles.horizontalScroll}>
        {leftBtn && (
          <button
            className={styles.btnLeft + ' d-none d-md-flex justify-content-start align-items-center'}
            onClick={() => handleScroll('L')}>
            <Image height={14} width={8} src={'/intstatic/icons/black-arrow-left.svg'} alt={'arrow left'} />
          </button>
        )}
        {quickLinks?.map((q) => {
          return (
            <PrefetchOnHoverLink href={q.path} key={q.label} className={q.selected ? styles.selected : ''}>
              {q.label}
            </PrefetchOnHoverLink>
          );
        })}
        {rightBtn && (
          <button
            className={styles.btnRight + ' d-none d-md-flex justify-content-end align-items-center'}
            onClick={() => handleScroll('R')}>
            <Image height={14} width={8} src={'/intstatic/icons/black-arrow-right.svg'} alt={'arrow right'} />
          </button>
        )}
      </div>
    </div>
  );
};

export default QuickLinks;
